import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

// Define the tenant API
export const tenantApi = createApi({
  reducerPath: 'tenantApi',
  baseQuery: baseQuery(),
  tagTypes: ['Tenant'], // Define a tag type for cache invalidation
  endpoints: (builder) => ({
    // Get current tenant information
    getCurrentTenant: builder.query({
      query: () => ({
        url: `/tenant/current`,
      }),
      providesTags: ['Tenant'],
    }),
    // Update tenant information
    updateTenant: builder.mutation({
      query: (body) => ({
        url: `/tenant/current`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Tenant'],
    }),
    // Join a tenant via invitation hash
    joinTenantByInvite: builder.mutation({
      query: ({ invitationHash }: { invitationHash: string }) => ({
        url: `/tenant/join`,
        method: 'PUT',
        body: { invitationHash },
      }),
      invalidatesTags: ['Tenant'],
    }),
  }),
});

export const {
  useGetCurrentTenantQuery,
  useUpdateTenantMutation,
  useJoinTenantByInviteMutation,
} = tenantApi;

export default tenantApi; 